import { render, staticRenderFns } from "./ListPriorityCart.vue?vue&type=template&id=97e7a0bc&scoped=true&"
import script from "./ListPriorityCart.vue?vue&type=script&lang=js&"
export * from "./ListPriorityCart.vue?vue&type=script&lang=js&"
import style0 from "./ListPriorityCart.vue?vue&type=style&index=0&id=97e7a0bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e7a0bc",
  null
  
)

export default component.exports